import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    heading: "Qu'est-ce que Helencia ?",
    body: [
      "Helencia est une plateforme qui relie deux familles de profils : les Talents (mannequins, modèles, acteurs, danseurs, performers, influenceurs, artistes) et les Créateurs (photographes, stylistes, MUAs, coiffeurs, vidéastes, directeurs artistiques, marques indépendantes, studios, agences, créateurs de mode, producteurs).",
      "Les Talents publient leur portfolio et postulent aux projets ; les Créateurs publient des collaborations et découvrent directement les Talents qualifiés.",
    ],
  },
  {
    heading: "Est-ce gratuit ?",
    body: [
      "L'inscription et l'utilisation de la plateforme sont gratuites pour tous. Les Talents peuvent choisir de passer Premium pour débloquer des avantages (portfolio illimité, visibilité accrue, accès prioritaire aux castings et concours).",
      "Les Créateurs peuvent publier leurs collaborations sans frais durant la phase de lancement.",
    ],
  },
  {
    heading: "Comment devenir Premium ?",
    body: [
      "Depuis votre espace Talent, rendez-vous sur « Premium » et choisissez la formule qui vous convient (1 mois, 3 mois ou 1 an). Le paiement est 100 % sécurisé via Stripe. Votre statut Premium est activé instantanément après le paiement.",
    ],
  },
  {
    heading: "Comment postuler à une collaboration ?",
    body: [
      "Depuis la page « Collaborations », cliquez sur un projet qui vous intéresse puis sur « Postuler ». Votre portfolio et votre profil sont automatiquement transmis au Créateur — vous n'avez rien d'autre à envoyer.",
      "Le statut de votre candidature (envoyée, consultée, acceptée, refusée) est visible dans « Mes candidatures ».",
    ],
  },
  {
    heading: "Comment les Créateurs sont-ils vérifiés ?",
    body: [
      "Notre équipe vérifie manuellement chaque compte Créateur (site, réseaux, SIRET ou portfolio pro). Un badge « Vérifié » apparaît sur leur profil une fois la validation effectuée.",
    ],
  },
  {
    heading: "Comment contacter l'équipe Helencia ?",
    body: [
      "Par email à hello@helencia.fr — nous répondons sous 48 h ouvrées.",
    ],
  },
];

export default function FAQ() {
  return <LegalPage title="Questions fréquentes" sections={SECTIONS} testid="faq-page" />;
}
